export const isFullStatic = false